module.exports = __webpack_public_path__ + "img/02_preview.3d0f03f7.png";